export enum MicrositeBlockType {
  SECTION = 'SECTION',
  CONTAINER = 'CONTAINER',
  HEADING = 'HEADING',
  PARAGRAPH = 'PARAGRAPH',
  IMAGE = 'IMAGE',
  BUTTON = 'BUTTON',
  DIVIDER = 'DIVIDER',
  SPACER = 'SPACER',
}

export const MICROSITE_BLOCK_TYPES: MicrositeBlockType[] =
  Object.values(MicrositeBlockType)
